import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarAdd4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalendarAdd4"><Path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H15.5V4H8.5V2H7V4ZM12.7491 9H11.2491V11.75H8.5V13.25H11.2491V16H12.7491V13.25H15.5V11.75H12.7491V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarAdd4;
